'use client'

import { CountDownBox } from '@/components/common/count-down-box'
import { CAMPAIGN_NAMES } from '@/lib/utils/campaign/campaign-names'
import { useCampaign } from '@/providers/campaign-provider'
import dayjs from 'dayjs'

export function HeroBannerCountdown() {
  const doubleDayCampaign = useCampaign(CAMPAIGN_NAMES.DOUBLE_DAY)

  if (!doubleDayCampaign?.isActive || !doubleDayCampaign?.end_at) {
    return null
  }

  return (
    <div className='pointer-events-none absolute inset-0 z-10 flex items-start justify-end pr-4 pt-[50px] md:ml-[60px] md:items-center md:justify-start md:pr-0 md:pt-0 lg:ml-[80px] 2xl:ml-[120px]'>
      <CountDownBox
        expiryTimestamp={dayjs(doubleDayCampaign.end_at).toDate()}
      />
    </div>
  )
}
